import api from "../../apiConfig";
import { returnSubjectPropParams } from "../utils/utils";

export const fetchHomes = async (bounds, activeFilters, subjectProperty, setHomes, setTooManyHomes, setLoading) => {
    setLoading(true);

    try {
        let queryString = `/homes?lat2=${bounds.ne.lat}&lng2=${bounds.ne.lng}&lat1=${bounds.sw.lat}&lng1=${bounds.sw.lng}`;
        
        // Build query string from activeFilters
        if (activeFilters.minPrice) queryString += `&minPrice=${activeFilters.minPrice}`;
        if (activeFilters.maxPrice) queryString += `&maxPrice=${activeFilters.maxPrice}`;
        if (activeFilters.lastUpdatedFrom) queryString += `&lastUpdatedFrom=${activeFilters.lastUpdatedFrom}`;
        if (activeFilters.lastUpdatedTo) queryString += `&lastUpdatedTo=${activeFilters.lastUpdatedTo}`;
        if (activeFilters.Lsc) queryString += `&listingStatus=${activeFilters.Lsc}`;
        if (activeFilters.bedrooms && activeFilters.bedrooms.length > 0) {
            queryString += `&bedrooms=${activeFilters.bedrooms.map((bed) => bed.includes('+') ? encodeURIComponent(bed) : bed).join(',')}`;
        }
        if (activeFilters.bathrooms && activeFilters.bathrooms.length > 0) {
            queryString += `&bathrooms=${activeFilters.bathrooms.map((bath) => bath.includes('+') ? encodeURIComponent(bath) : bath).join(',')}`;
        }
        if (activeFilters.Sqft && activeFilters.Sqft.length > 0) queryString += `&squareFootage=${activeFilters.Sqft}`;
        if (activeFilters.A_c && activeFilters.A_c.length > 0) queryString += `&acOptions=${activeFilters.A_c}`;
        if (activeFilters.Bsmt1_out && activeFilters.Bsmt1_out.length > 0) queryString += `&basementOptions=${activeFilters.Bsmt1_out}`;
        if (activeFilters.kitchenOptions && activeFilters.kitchenOptions.length > 0) queryString += `&kitchenOptions=${activeFilters.kitchenOptions}`;
        if (activeFilters.Tot_park_spcs && activeFilters.Tot_park_spcs.length > 0) queryString += `&parkingSpaces=${activeFilters.Tot_park_spcs}`;
        if (activeFilters.Yr_built && activeFilters.Yr_built.length > 0) queryString += `&ageOptions=${activeFilters.Yr_built}`;
        // Always tell the API where the subject property is …
        queryString += `&subjectHomeLat=${subjectProperty.Latitude}` +
                       `&subjectHomeLng=${subjectProperty.Longitude}`;

        // … then add searchRadius only when the user actually set one
        if (activeFilters.searchRadius) {
            queryString += `&searchRadius=${activeFilters.searchRadius}`;
        }

        const response = await api.get(queryString);
        const data = response.data;

        const tooManyHomes = data.message === 'Too many homes found. Please narrow down your search.';
        setTooManyHomes(tooManyHomes);
        if (tooManyHomes) {
            setHomes([]);
            return;
        }

        const comparableMlNums = data.map((home) => home.Ml_num).join(',');
        const subjectPropParamsActual = returnSubjectPropParams(subjectProperty);
        console.log("DEBUG (FetchHomes) subjectPropParamsActual:", subjectPropParamsActual);
        console.log("DEBUG (FetchHomes) sending relevance payload:", {
          subjectPropertyNum: subjectProperty.Ml_num,
          subjectPropertyLat: subjectProperty.Latitude,
          subjectPropertyLng: subjectProperty.Longitude,
          comparables: comparableMlNums,
          subjectPropParams: subjectPropParamsActual
        });
        const relevanceScoresResponse = await api.post("/homes/relevance", {
          subjectPropertyNum: subjectProperty.Ml_num,
          subjectPropertyLat: subjectProperty.Latitude,
          subjectPropertyLng: subjectProperty.Longitude,
          comparables: comparableMlNums,
          subjectPropParams: subjectPropParamsActual
        });
        const relevanceScores = relevanceScoresResponse.data.scores;

        const homesWithImages = data.map((home) => ({
            ...home,
            score: relevanceScores[home.Ml_num],
            image: `https://realtime-home-images.s3.amazonaws.com/${home.Ml_num}/1.jpeg`,
        }));
        setHomes(homesWithImages);
    } catch (error) {
        console.error('Error fetching homes:', error);
    } finally {
        setLoading(false);
    }
};